<!-- <h2>Location and Product Details</h2>

<div *ngIf="location && title">
  <p><strong>Location Name:</strong> {{ location.name }}</p>
  <img [src]="location.icon" [alt]="location.name" />
  <p><strong>Product Title:</strong> {{ title }}</p>
</div>

<div *ngIf="!location || !title">
  <p>No data available.</p>
</div> -->






<div class="main px-md-5 px-3 py-4 pb-0 pb-sm-4">
  <div>
    <div class="row mt-4">
      <div class="col-md-3">
        <div class="filterbox">
          <h3 class="my-4"><img src="assets/images/new_img/filtericon.svg"> FILTERS</h3>
          
          <div class="filter-section">
            <div class="filter-title">
              <h4 class="d-flex justify-content-between">
                <span>Offerings</span>
                <button
                  class="btn btn-link toggle-icon"
                  type="button"
                  (click)="toggle()"
                  data-bs-toggle="collapse"
                  data-bs-target="#offeringsFilter"
                  aria-expanded="false"
                  aria-controls="offeringsFilter">
                  <img
                    [src]="isToggled ? 'assets/images/new_img/arrow-bottom.svg' : 'assets/images/new_img/arrow-top.svg'"
                    alt="Arrow Toggle">
                </button>
              </h4>
            </div>
            <div class="collapse show" id="offeringsFilter">
              
                <ul class="list-unstyled">
                  <li *ngFor="let item of industry; let i = index">
                    <div class="form-check custom-radio" (change)="selectIndustry(item?.id)">
                      <input
                        class="form-check-input"
                        name="Industry"
                        type="radio"
                        [id]="'industry_' + i"
                        [checked]="selectedParams.industryId === item.id"
                      />
                      <label class="form-check-label" [for]="'industry_' + i">
                        {{ item.industry_name }}
                      </label>
                    </div>
                  </li>
                </ul>
              
            </div>
          </div>
          
          <div class="divider" *ngIf="selectedIndustry !== 0"> </div>
          
          <div class="filter-section"  *ngIf="AllSubCategory1.length>0">
            <div class="filter-title">
              <h4 class="d-flex justify-content-between">
                <span>Industry</span>
                <button
                  class="btn btn-link toggle-icon"
                  type="button" 

                  data-bs-toggle="collapse"
                  data-bs-target="#subCategoryFilter1"
                  aria-expanded="false"
                  aria-controls="subCategoryFilter1">
                  <img
                    [src]="isToggled ? 'assets/images/new_img/arrow-bottom.svg' : 'assets/images/new_img/arrow-top.svg'"
                    alt="Arrow Toggle">
                </button>
              </h4>
            </div>
            
            <div class="collapse show" id="subCategoryFilter1">
              
                <ul class="list-unstyled" *ngIf="AllSubCategory1.length > 0">
                  <li *ngFor="let item of AllSubCategory1; let i = index">
                    <div class="form-check custom-radio" (click)="show_product(item)">
                      <input
                        class="form-check-input"
                        name="SubCategory1"
                        type="radio"
                        [id]="'subCategory1_' + i"
                        [checked]="selectedParams.subCategory1Id === item.id"
                      />
                      <label class="form-check-label" [for]="'subCategory1_' + i">
                        {{ item.title }}
                      </label>
                    </div>
                  </li>
              </ul>
            </div>
          </div>

          <div class="divider" *ngIf="AllSubCategory2.length > 0"> </div>
          <div class="filter-section" *ngIf="AllSubCategory2.length>0">
            <div class="filter-title">
              <h4 class="d-flex justify-content-between">
                <span>Category</span>
                <button
                  class="btn btn-link toggle-icon"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#subCategoryFilter2"
                  aria-expanded="false" 
                  aria-controls="subCategoryFilter2">
                  <img [src]="isToggled ? 'assets/images/new_img/arrow-bottom.svg' : 'assets/images/new_img/arrow-top.svg'"
                    alt="Arrow Toggle">
                </button>
              </h4>
            </div>
            <div class="collapse show" id="subCategoryFilter2">
                <ul  class="list-unstyled" *ngIf="AllSubCategory2.length > 0">
                  <li *ngFor="let item of AllSubCategory2; let i = index">
                    <div class="form-check custom-radio" (click)="selectSubCategory2(item)">
                      <input
                        class="form-check-input"
                        name="SubCategory2"
                        type="radio"
                        [id]="'subCategory2_' + i"
                        [checked]="selectedParams.subCategory2Id === item.id"
                      />
                      <label class="form-check-label" [for]="'subCategory2_' + i">
                        {{ item.title }}
                      </label>
                    </div>
                  </li>
                </ul>
            </div>
          </div>
          
          <div class="divider" *ngIf="AllSubCategory3.length > 0"> </div>
          <div class="filter-section" *ngIf="AllSubCategory3.length>0">
            <div class="filter-title">
              <h4 class="d-flex justify-content-between">
                <span>Sub Category</span>
                <button
                  class="btn btn-link toggle-icon"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#subCategoryFilter3"
                  aria-expanded="false" 
                  aria-controls="subCategoryFilter3">
                  <img [src]="isToggled ? 'assets/images/new_img/arrow-bottom.svg' : 'assets/images/new_img/arrow-top.svg'"
                    alt="Arrow Toggle">
                </button>
              </h4>
            </div>
            <div class="collapse show" id="subCategoryFilter3">
            

              <ul class="list-unstyled" *ngIf="AllSubCategory3.length > 0">
                <li *ngFor="let item of AllSubCategory3; let i = index">
                  <div class="form-check custom-radio" (click)="selectSubCategory3(item)">
                    <input
                      class="form-check-input"
                      name="SubCategory3"
                      type="radio"
                      [id]="'subCategory3_' + i"
                      [checked]="selectedParams.subCategory3Id === item.id"
                    />
                    <label class="form-check-label" [for]="'subCategory3_' + i">
                      {{ item.title }}
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="divider" *ngIf="AllBrandList.length > 0"> </div>
          <div class="filter-section" *ngIf="AllBrandList.length > 0">
            <div class="filter-title">
              <h4 class="d-flex justify-content-between">
                <span>Brand</span>
                <button class="btn btn-link toggle-icon" type="button" data-bs-toggle="collapse"
                  data-bs-target="#brandFilter" aria-expanded="false" aria-controls="brandFilter">
                  <img
                    [src]="isToggled ? 'assets/images/new_img/arrow-bottom.svg' : 'assets/images/new_img/arrow-top.svg'"
                    alt="Arrow Toggle">
                </button>
              </h4>
            </div>
            <div class="collapse show" id="brandFilter">


              <ul class="list-unstyled" *ngIf="AllBrandList.length > 0">
                <li *ngFor="let item of AllBrandList; let i = index">
                  <div class="form-check custom-radio" (click)="selectBrands(item)">
                    <input class="form-check-input" name="brandFilter" type="radio" [id]="'brandFilter_' + i"
                      [checked]="selectedParams.brand_id === item.id" />
                    <label class="form-check-label" [for]="'brandFilter_' + i">
                      {{ item.brand_name }}
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="divider" *ngIf="AllBrandList.length > 0"> </div>
          <div class="filter-section" *ngIf="selectedParams.subCategory1Id === job_work_id">
            <div class="filter-title">
              <h4 class="d-flex justify-content-between">
                <span>Job Type</span>
                <button class="btn btn-link toggle-icon" type="button" data-bs-toggle="collapse"
                  data-bs-target="#job_Type_Filter" aria-expanded="false" aria-controls="job_Type_Filter">
                  <img
                    [src]="isToggled ? 'assets/images/new_img/arrow-bottom.svg' : 'assets/images/new_img/arrow-top.svg'"
                    alt="Arrow Toggle">
                </button>
              </h4>
            </div>
            <div class="collapse show" id="job_Type_Filter">

              <ul class="list-unstyled" *ngIf="jobTypes.length > 0">
                <li *ngFor="let item of jobTypes; let i = index">
                  <div class="form-check custom-radio" (click)="selectJobType(item)">
                    <input class="form-check-input" name="job_type_Filter" type="radio" [id]="'job_type_Filter_' + i"
                      [checked]="selectedParams.job_type === item.name" />
                    <label class="form-check-label" [for]="'job_type_Filter_' + i">
                      {{ item.name }}
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>

<!--           

          <div class="divider" *ngIf="selectedIndustry!==0"> </div>
          <div class="filter-section" *ngIf="industries.length>0">
            <div class="filter-title">
              <h4 class="d-flex justify-content-between">
                <span>Sub-Category</span>
                <button class="btn btn-link toggle-icon" type="button" data-bs-toggle="collapse"
                  data-bs-target="# " aria-expanded="false" aria-controls="industryFilter2"
                  style="padding: 0;">
                  <img src="assets/images/new_img/arrow-top.svg" alt="Arrow Top" style="vertical-align: sub;">
                </button>
              </h4>
            </div>


            <div class="collapse show" id="industryFilter2">
              <ul class="list-unstyled">
                <li *ngFor="let industry of industries" class="mb-2">
                  <div class="form-check custome-checkbox">
                    <input class="form-check-input" type="checkbox" [id]="industry.title"
                      (change)="filterProducts(industry.id, industry.title)"
                      [(ngModel)]="selectedIndustries[industry.title]" />
                    <label class="form-check-label custom-checkbox-label" [for]="industry.title">{{
                      industry.title }}</label>
                  </div>
                </li>

              </ul>
            </div>
          </div> -->

        </div>
      </div>

      <div class="col-md-9">
        <div class="row">
          <div class="col-md-8">
            <div *ngIf="title || location">
              <h3 class="mt-2 mt-sm-0 mb-0 mb-sm-1 mb-md-1"><span>Search Results for</span> <span class="text-capitalize"> “{{ title || location }}” </span></h3>
              <!-- <p> {{Searchresults?.length}} Products</p> -->
              <p>
                Showing
                {{ (currentPage - 1) * numberOfProducts + 1 }} –
                {{ Math.min(currentPage * numberOfProducts, totalCount) || Searchresults.length}}
                of {{ totalCount || Searchresults.length }} Results for "{{ selectedIndustryName }}"
              </p>
            </div>
          </div>

          <div class="col-md-4 mt-2 mt-sm-0">
            <div class="sort-by d-flex  align-items-center custom-mat-select mb-4">
              <p>Sort by: </p>
              <mat-form-field appearance="fill" class="custom-mat-select">
                <mat-select placeholder="Select an option" [(ngModel)]="selectedSortOption"
                    (selectionChange)="onSortChange()">
                    <mat-option value="recent">Recent</mat-option>
                    <mat-option value="popularity">Popularity</mat-option>
                    <mat-option value="ASC">Ascending</mat-option>
                    <mat-option value="DESC">Descending</mat-option>
                </mat-select>
            </mat-form-field>
            </div>
          </div>
        </div>
        
        <div class="row" *ngIf="Searchresults.length > 0; else noProducts">
          <div class="col-md-4 mb-4 col-sm-6" *ngFor="let items of Searchresults">
            <div class="normalbox">
              <div (click)="viewSingleProduct(items.id,items?.Industry?.industry_name)">
                <span class="newtick" *ngIf="items?.is_new === true">New</span>
                <div class="normalboximg" *ngIf="items">
                  <img *ngIf="items.Media && items.Media.length > 0" [src]="items.Media[0]?.url"
                    class="img-fluid normalimg" alt="{{ items.title }}" />
                </div>
                <div class="normalboxDetail">
                  <div class="catServices">{{ items?.Industry?.industry_name }}</div>
                  <h5>
                    {{items?.Category3?.title == 'Other' ? items?.category3_name :
                items?.Category3?.title }}
                  </h5>
                  <!-- <p class="location d-flex align-items-center"><span><img src="assets/images/locations.svg"
                        class="img-fluid me-2" alt="location"></span>
                    <span> {{ items.location }}</span>
                  </p> -->
                  <p class="location d-flex align-items-center">
                    <span *ngIf="items.stateDetails?.name"><img src="assets/images/locations.svg" class="img-fluid me-2"
                        alt="location"></span>
   <span *ngIf="items?.stateDetails?.name">{{
  items?.cityDetails?.city }}<span
  *ngIf="items?.cityDetails?.city != null && items?.cityDetails?.city != 'null'">,</span> {{
      items?.stateDetails?.name | titlecase }}</span>
                  </p>
                  <!-- <p class="location d-flex align-items-center" *ngIf="items?.UserAuth?.company_name">
                    <span> {{items?.UserAuth?.company_name}}</span>
  
                 </p> -->
                  <div class="price" *ngIf="items?.price != 'null' && items?.price != null">
                    {{ items?.category1_id == '9595821e-9d59-4218-b516-ed77d4aa7a76' ? 'Max Loan Up To' : 'Price' }}
                    <span class="pricebold">{{ (items?.price) ? (' ₹ ' + (items?.price | commaSeparated)) + "/-" : 'On Request' }}</span>
                    <!-- <span *ngIf="items?.punit">/{{items?.punit || ''}}</span> -->
                  </div> 
                  <div class="ContactSeller mt-2">
                    <a> Contact the Seller</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="isPaginationEnabled && Searchresults.length>0" class="d-flex flex-column flex-md-row align-items-center">
            <div class="pagination-info text-center text-md-start">
              <p>Page {{ currentPage }} of {{ totalPages }}</p>
            </div>
            <nav *ngIf="isPaginationEnabled" aria-label="Page navigation"
              class="d-flex align-items-center justify-content-md-center ms-sm-5 ms-md-5 ms-0">
              <ul class="pagination flex-wrap justify-content-md-center">
                <li class="page-item custom-text-button" [ngClass]="{ 'disabled': currentPage === 1 }">
                  <a class="page-link" (click)="goToPage(currentPage - 1)">Previous</a>
                </li>
                <li class="page-item" *ngFor="let page of pages" [ngClass]="{ 'active': page === currentPage }">
                  <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
                </li>
                <li class="page-item custom-text-button" [ngClass]="{ 'disabled': currentPage === totalPages }">
                  <a class="page-link" (click)="goToPage(currentPage + 1)">Next</a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <ng-template #noProducts>
          <div class="no-products text-center">
            <div class="row justify-content-center">
            <div class="col-md-4">
            <img src="assets/images/coming-soon-creative.jpg" class="img-fluid" style="  cursor: pointer; width: 100%;
"  (click)="enquiry()">
            </div>
          </div>
          </div>
        </ng-template>

      </div>

    </div>


  </div>
</div>